
import { useEffect, useState } from "react"
import { motion } from "framer-motion"
import { cn } from "../../utils/cn"

export const TextGenerateEffect = ({ words, className }) => {
  const [renderedText, setRenderedText] = useState("")
  const [isComplete, setIsComplete] = useState(false)

  useEffect(() => {
    const timeout = setTimeout(() => {
      if (renderedText.length < words.length) {
        setRenderedText(words.substring(0, renderedText.length + 1))
      } else {
        clearTimeout(timeout)
        setIsComplete(true)
      }
    }, 30)

    return () => clearTimeout(timeout)
  }, [words, renderedText])

  return (
    <motion.div
      className={cn("font-bold", className)}
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{ duration: 1 }}
    >
      {renderedText}
      {!isComplete && (
        <motion.span
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ duration: 0.5, repeat: Number.POSITIVE_INFINITY, repeatType: "reverse" }}
        >
          |
        </motion.span>
      )}
    </motion.div>
  )
}
